// Vendor Libraries
import { combineReducers } from '@ngrx/store';
// Reducers
import { preferenceIndicesCalcs } from 'IndicesApp/ts/apps/index-family-app/state/family-indices-table/family-indices-table.reducer';
export const rootReducer = combineReducers({
    preferenceIndicesCalcs,
});
